import { CopyButton } from './copy-button';
import { useDebugToolPosVendor } from './use-debug-tool-pos-vendor';

export const StoreInfo = () => {
  const { storeNumber, storePosVendor } = useDebugToolPosVendor();
  const label = `Store Number: ${storeNumber} - ${storePosVendor}`;
  return <CopyButton label={label} textToCopy={storeNumber} variant="headerTwo" />;
};
